<template>
	<v-layout align-start>
		<v-container>
			<v-breadcrumbs class="pl-0" :items="items">
				<template v-slot:item="{ item }">
					<v-breadcrumbs-item
						:to="item.href"
						:disabled="item.disabled"
					>
						{{ item.text}}
					</v-breadcrumbs-item>
				</template>
			</v-breadcrumbs>
			<v-toolbar
				flat
			>
				<v-toolbar-title>Estudiantes</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-text-field
					v-model="search"
					append-icon="mdi-magnify"
					label="Buscar"
					single-line
					hide-details
					dense
                    outlined
				></v-text-field>
				<v-spacer></v-spacer>
				<v-btn
					color="#1486bd"
					dark
					@click="dialog = true"
				>
					<span class="text-capitalize text-body">nuevo</span> 
				</v-btn>
				<v-dialog
				v-model="dialog"
				max-width="600px"
				>
					<v-card>
						<v-card-title>
							<span class="text-h5">{{ formTitle }}</span>
						</v-card-title>

						<v-card-text>
							<v-container>
								<v-form ref="form">
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            sm="6"
                                            md="6"
                                            class="py-0"
                                        >
                                            <p class="mb-2">Nombres</p>
                                            <v-text-field
                                                v-model="formStudent.names"
                                                class="pt-0"
                                                label="Nombres"
                                                placeholder="Nombres"
                                                single-line
                                                dense
                                                outlined
												autocomplete="null"
                                                :rules="nameRules"
                                            >
                                            </v-text-field>
                                        </v-col>
										<v-col
                                            cols="12"
                                            sm="6"
                                            md="6"
                                            class="py-0"
                                        >
                                            <p class="mb-2">Apellidos</p>
                                            <v-text-field
                                                v-model="formStudent.surnames"
                                                class="pt-0"
                                                label="Apellidos"
                                                placeholder="Apellidos"
                                                single-line
                                                dense
                                                outlined
												autocomplete="null"
                                                :rules="surnameRules"
                                            >
                                            </v-text-field>
                                        </v-col>
										<v-col
                                            cols="12"
                                            sm="6"
                                            md="6"
                                            class="py-0"
                                        >
                                            <p class="mb-2">Ci</p>
                                            <!--v-text-field
                                                v-model="formStudent.ci"
                                                class="pt-0"
                                                label="Ci"
                                                placeholder="Ci"
                                                single-line
                                                dense
                                                outlined
												autocomplete="null"
                                                :rules="ciRules"
                                            >
                                            </v-text-field-->
											<v-text-field
                                                v-model="formStudent.ci"
                                                class="pt-0"
                                                label="Ci"
                                                placeholder="Ci"
                                                single-line
                                                dense
                                                outlined
												autocomplete="null"
												:rules="ciRules"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="6"
                                            md="6"
                                            class="py-0"
                                        >
                                            <p class="mb-2">Telefono</p>
                                            <v-text-field
                                                v-model="formStudent.phone"
                                                class="pt-0"
                                                label="Telefono"
                                                placeholder="Telefono"
                                                single-line
                                                dense
                                                outlined
												autocomplete="null"
                                                :rules="phoneRules"
                                            >
                                            </v-text-field>

                                        </v-col>
										<!--template v-if="user.idRol == 1">
											<v-col
												cols="12"
												sm="6"
												md="6"
												class="py-0"
											>
												<p class="mb-2">Usuario</p>
												<v-text-field
													v-model="formStudent.user"
													class="pt-0"
													label="Usuario"
													placeholder="Usuario"
													single-line
													dense
													outlined
												>
												</v-text-field>
											</v-col>
											<v-col
												cols="12"
												sm="6"
												md="6"
												class="py-0"
											>
												<p class="mb-2">Contraseña</p>
												<v-text-field
													v-model="formStudent.password"
													class="pt-0"
													:append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
													:type="passwordShow ? 'text' : 'password'"
													label="Password"
													placeholder="Password"
													@click:append="passwordShow = !passwordShow"
													single-line
													dense
													outlined
												>
												</v-text-field>

											</v-col>
										</template-->
										<v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="py-0"
                                        >
                                            <p class="mb-2">Email</p>
                                            <v-text-field
                                                v-model="formStudent.email"
                                                class="pt-0"
                                                label="Email"
                                                placeholder="Email"
                                                single-line
                                                dense
                                                outlined
												autocomplete="null"
                                            >
                                            </v-text-field>

                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="6"
                                            md="6"
                                            class="py-0"
											v-if="user.idRol == 1"
                                        >
                                            <p class="mb-2">Sucursal</p>
                                            <v-select
                                                v-model="formStudent.idBranchoffice"
                                                :items="branchoffices"
                                                item-text="nombreSucursal"
                                                item-value="idSucursal"
                                                label="Sucursal"
                                                persistent-hint
                                                dense
                                                outlined
                                                single-line
                                                :rules="branchofficeRules"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
								</v-form>
							</v-container>
						</v-card-text>

						<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							:disabled="loadingData"
							@click="close"
						>
							<span class="text-capitalize">Cancelar</span>
						</v-btn>
						<v-btn
							color="blue darken-1"
							dark
							:loading="loadingData"
							@click="saveStudent"
						>
							<span class="text-capitalize">Guardar</span>						
						</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog v-model="dialogDelete" max-width="400px">
					<v-card>
						<p style="color: #1874BF" class="text-h6 text-center pt-4">Informe de Estudiante</p>
						<v-card-text v-if="(user.idRol == 1)" class="text-center">
							{{`¿Esta seguro de ${editedItem.estado ? 'desactivar' : 'activar'} el estudiante ${editedItem.nombres}?`}}
						</v-card-text>
						<v-card-text v-else class="text-center">
							¿Esta seguro de eliminar el estudiante {{editedItem.nombres}}?
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="blue darken-1" text @click="closeDelete">No</v-btn>
							<v-btn dark color="blue darken-1" @click="deleteItemConfirm">Si</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-toolbar>
			<v-container v-if="loading" class="d-flex justify-center">
				<v-progress-circular 
					indeterminate
					color="primary"
				></v-progress-circular>
			</v-container>
			<template v-if="students.length > 0">
				<v-data-table
					:headers="user.idRol == 1 ? headersAdmin : headers"
					:items="students"
					:search="search"
					item-key="idUsuario"
					class="elevation-1 font-weight-light caption"
					
					fixed-header
				>
                    <template v-slot:[`item.fechaInicio`]="{item}">
                        {{formatDate(item.fechaInicio.substring(0, 10))}}
                    </template>
					<template v-slot:[`item.password`]="{item}">
						{{show ? item.password : '.......'}}
						<v-btn small icon @click="showPassword(item)">
							<v-icon small>{{show ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
						</v-btn>
					</template>
					<template v-slot:[`item.estado`]="{item}">
						{{item.estado ? 'Activo' : 'Inactivo'}}
					</template>
					<template v-slot:[`item.accion`]="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{on,attrs}">
								<v-btn
									icon
									color="primary"
									class="mr-2"
									@click.stop="editItem(item)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Editar</span>
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{on,attrs}">
								<v-btn
									icon
									:color="item.estado ? 'error' : 'success'"
									class="mr-2"
									@click.stop="deleteItem(item)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon v-if="user.idRol == 1">{{item.estado ? 'mdi-cancel' : 'mdi-check'}}</v-icon>
									<v-icon v-else>mdi-delete</v-icon>
								</v-btn>
							</template>
							<span v-if="user.idRol == 1">{{item.estado ? 'Desactivar' : 'Activar'}}</span>
							<span v-else>Eliminar</span>
						</v-tooltip>
					</template>
				</v-data-table>
			</template>
			<template v-else>
				<v-card elevation="0" outlined v-if="loading == false">
					<v-card-text class="text-center pb-0">No existen Estudiantes Registrados.</v-card-text>
					<v-card-text class="text-center pt-0"><v-btn color="blue darken-1" dark small class="my-2 px-2" tile elevation="0" @click="selectStudents">Volver a Intentar</v-btn></v-card-text>
				</v-card>
			</template>
			<v-dialog v-model="dialogTransfer" max-width="400px">
				<v-card>
					<p style="color: #1874BF" class="text-h6 text-center pt-4">Informe de Transferencia</p>
					<v-card-text class="text-center">
						{{message}}
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" text @click="closeTransfer">No</v-btn>
						<v-btn dark color="blue darken-1" @click="transferConfirm">Si</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-snackbar
				text
				v-model="snackbar"
				:color="colorSnackbar"
			>
				<span class="text-center">{{ textSnackbar }}</span>
			</v-snackbar>
		</v-container>
	</v-layout>  
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
export default {
	data(){
		return {
			dialog: false,
			dialogDelete: false,
			headers: [
				{text: "Ci", value: "ci", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				{text: "Apellidos", value: "apellidos", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				{text: "Nombres", value: "nombres", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				{text: "Email", value: "email", align: 'center', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				//{text: "Usuario", value: "usuario", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				//{text: "Password", value: "password", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
                {text: "Sucursal", value: "nombreSucursal", align: 'center', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
                {text: "Acciones", value: "accion", align: 'center', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
			],
			headersAdmin: [
				{text: "Ci", value: "ci", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				{text: "Apellidos", value: "apellidos", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				{text: "Nombres", value: "nombres", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				{text: "Email", value: "email", align: 'center', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				//{text: "Usuario", value: "usuario", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				//{text: "Password", value: "password", align: 'left', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
                {text: "Sucursal", value: "nombreSucursal", align: 'center', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
				{text: "Estado", value: "estado", align: 'center', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
                {text: "Acciones", value: "accion", align: 'center', sortable: false, class: 'font-weight-bold blue-grey lighten-5'},
			],
			students: [],
			editedIndex: -1,
            formStudent:{
                idStudent: '',
				names: '',
				surnames: '',
				ci: '',
				email: '',
				phone: '',
				idBranchoffice: '',
				idRole: 6,
                creationDate: new Date().toISOString().substring(0, 10),
				user: '',
				password: '',
            },
			nameRules: [
				value => !!value || 'Ingrese nombres',
			],
            surnameRules: [
                value => !!value || 'Ingrese apellidos'
            ],
            ciRules: [
                value => !!value || 'Ingrese un ci'
            ],
            emailRules: [
                value => !!value || 'Ingrese un email',
                value => /.+@.+\..+/.test(value) || 'Debe ingresar un email correcto',
            ],
            phoneRules: [
                value => !!value || 'Ingrese un numero de telefono',
				value => /^(\d{8}-\d{8}|\d{8})$/.test(value) || 'Debe ingresar un formato correcto'
            ],
			branchofficeRules: [
                value => !!value || 'Seleccione una sucursal'
            ],
			loading: false,
			loadingData: false,
			snackbar: false,
			colorSnackbar: '',
			textSnackbar: '',
			editedItem: {},
			defaultItem: {
				name: '',
				calories: 0,
				fat: 0,
				carbs: 0,
				protein: 0,
			},
			items: [
				{
					text: 'Estudiantes',
					disabled: false,
					href: '/student',
				},
			],
            menu2: false,
            branchoffices: [],
			roles: [],
			show: false,
			passwordShow: false,
			//transferStudent
			dialogTransfer: false,
			userData: {},
			message: '',
			idBranchofficeTransfer: '',
			search: '',
		}
	},
	computed: {
		...mapState(['user','idDepartament']),
		formTitle () {
			return this.editedIndex === -1 ? 'Nuevo Estudiante' : 'Editar Estudiante';
		},
        computedDateFormatted () {
            return this.formatDate(this.formStudent.startDate);
        },
	},
	watch: {
		dialog (val) {
			val || this.close()
		},
		dialogDelete (val) {
			val || this.closeDelete()
		},
	},
	created () {
		this.selectStudents();
        this.selectBranchoffices();
	},
	methods: {
		//transferStudent
		async updateTransferUser(data){
			try {
				let response = await axios.put('users/updateTransferUser',data);
				if (response.status == 200) {
					this.closeTransfer();
					this.notification('success',response.data['msg']);
					this.selectStudents();
				}
			} catch (error) {
				console.log(error);
				this.notification('error','Ocurrio algo inesperado. Por favor intente de nuevo.');
			}
		},
		transferConfirm(){
			let data = {
				idBranchoffice: this.idBranchofficeTransfer,
				idUser: this.userData.idUsuario,
			}

			this.updateTransferUser(data);
		},
		closeTransfer(){
			this.dialogTransfer = false;
			this.userData = {};
			this.message = '';
			this.idBranchofficeTransfer = '';
		},
		//otherModule
		showPassword(item){
			console.log(item);
			this.show = !this.show;
		},
		clickRow(){

		},
		async deleteUser(data){
			try {
				let response = await axios.put('users/deleteUser',data);
				if (response.status == 200) {
					this.closeDelete();
					this.notification('warning',this.user.idRol == 1 ? response.data['msg'] : 'Se elimino el estudiante');
					this.selectStudents();
				}
			} catch (error) {
				console.log(error);
				this.notification('error','Ocurrio algo inesperado. Por favor intente de nuevo.');
			}
		},
		async insertStudent(data){
			try {
				let response = await axios.post('users/insertStudent',data);
				if (response.status == 200) {
					if(response.data.type == 0 || response.data.type == 1 || response.data.type == 2){
						this.close();
						this.loadingData = false;
						this.notification('success',response.data['msg']);
						this.selectStudents();
					} else{
						this.idBranchofficeTransfer = this.formStudent.idBranchoffice;
						this.close();
						this.loadingData = false;
						this.userData = response.data.data;
						this.message = response.data.msg;
						this.dialogTransfer = true;
					}
					
				}
			} catch (error) {
				console.log(error);
				this.loadingData = false;
				this.notification('error','Ocurrio algo inesperado. Por favor intente de nuevo.');
			}
		},
		async updateStudent(data){
			try {
				let response = await axios.put('users/updateStudent',data);
				if (response.status == 200) {
					this.close();
					this.loadingData = false;
					this.notification('success',response.data['msg']);
					this.selectStudents();
				}
			} catch (error) {
				console.log(error);
				this.loadingData = false;
				this.notification('error','Ocurrio algo inesperado. Por favor intente de nuevo.');
			}
		},
		saveStudent () {
			if (this.$refs.form.validate()) {
				if (this.editedIndex > -1) {
					//modificar
					let data = {
						names: this.formStudent.names.toUpperCase().trim(),
						surnames: this.formStudent.surnames.toUpperCase().trim(),
						ci: this.formStudent.ci.trim(),
						email: this.formStudent.email.trim(),
						phone: this.formStudent.phone.trim(),
						idBranchoffice: this.user.idRol == 1 ? this.formStudent.idBranchoffice : this.user.idSucursal,
						idRole: this.formStudent.idRole,
						idStudent: this.formStudent.idStudent
					}
					
					this.loadingData = true;
					this.updateStudent(data);
				} else {
					let data = {
						names: this.formStudent.names.toUpperCase().trim(),
						surnames: this.formStudent.surnames.toUpperCase().trim(),
						ci: this.formStudent.ci.trim(),
						email: this.formStudent.email.trim(),
						phone: this.formStudent.phone.trim(),
						idBranchoffice: this.user.idRol == 1 ? this.formStudent.idBranchoffice : this.user.idSucursal,
						idRole: this.formStudent.idRole,
						user: '',/*this.user.idRol == 1 ? this.formStudent.user.trim() : null,*/
						pass: '',/*this.user.idRol == 1 ? this.formStudent.password.trim() : null,*/
						idDepartament: this.idDepartament,
					};
					this.loadingData = true;
					
					this.insertStudent(data);
				}
			}
		},

		async selectStudents(){
			let url = this.user.idRol == 1 ? `users/selectStudents/${this.idDepartament}/null` : `users/selectStudents/${this.idDepartament}/1`;
			try {
				this.loading = true;
				let response = await axios.get(url);
				if (response.status == 200) {
					this.students = response.data;
					this.loading = false;
				}
			} catch (error) {
				console.log(error);
				this.loading = false;
			}
		},
        async selectBranchoffices(){
			let url = `branchoffices/selectBranchoffices/${this.idDepartament}/1`;
            try {
                let response = await axios.get(url);
                if (response.status == 200) {
                    this.branchoffices = response.data;
                }
            } catch (error) {
                console.log(error);
            }
        },

		notification(type,text){
			this.snackbar = true;
			this.colorSnackbar = type;
			this.textSnackbar = text;
		},

		editItem (item) {
			this.editedIndex = 1;
			this.editedItem = Object.assign({}, item);
			this.formStudent.idStudent = this.editedItem.idUsuario;
			this.formStudent.names = this.editedItem.nombres;
			this.formStudent.surnames = this.editedItem.apellidos;
			this.formStudent.ci = this.editedItem.ci;
			this.formStudent.email = this.editedItem.email;
			this.formStudent.phone = this.editedItem.telefono;
			this.formStudent.idBranchoffice = this.editedItem.idSucursal;
			this.formStudent.idRole = this.editedItem.idRol;
			this.dialog = true;
		},

		deleteItem (item) {
			this.editedItem = Object.assign({}, item);
			this.dialogDelete = true;
		},

		deleteItemConfirm () {
			let data = {
				idUser: this.editedItem.idUsuario,
				state: this.editedItem.estado ? 0 : 1,
			}
			this.deleteUser(data);
		},

		close () {
			this.editedIndex = -1;
			this.$refs.form.resetValidation();
			this.formStudent.idStudent = '';
			this.formStudent.names = '';
			this.formStudent.surnames = '';
			this.formStudent.ci = '';
			this.formStudent.email = '';
			this.formStudent.phone = '';
			this.formStudent.idBranchoffice = '';
			this.formStudent.idRole = 6;
			this.dialog = false;
		},

		closeDelete () {
			this.dialogDelete = false;
			this.editedItem = '';
		},
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
		
	}
}
</script>

<style>
	/*.td-click td{
		/*cursor: pointer;
	}*/
</style>